import { render } from "./MixRawMaterialsModal.vue?vue&type=template&id=63a3782c&ts=true"
import script from "./MixRawMaterialsModal.vue?vue&type=script&lang=ts"
export * from "./MixRawMaterialsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__